;(function() {
  const $ = window.$
  return (module.exports = $('[http-equiv="X-UA-App-Name"]').attr('content'))
})()
